// @ts-check
/// <reference lib="dom" />
/// <reference lib="es2020" />

/* eslint-disable react-hooks/rules-of-hooks */
import { ApplicationController as Controller } from 'stimulus-use';

/**
 * Application controller extending Stimulus controller
 * @extends {Controller}
 */
export class ApplicationController extends Controller {
  /**
   * Called when the controller is connected to the DOM
   * @returns {void}
   */
  connect() {
    if (
      process.env.NODE_ENV === 'test' ||
      process.env.NODE_ENV === 'development'
    ) {
      console.log('Hello from stimulus');
    }
  }
}
